import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { useActiveWorkspaceAssigment } from "@hooks/permissions/useActiveWorkspaceAssignment";
import { useActiveOrganizationAssignment } from "@hooks/permissions/organization/useActiveOrganizationAssignment";
import { useTypedFlags } from "@hooks/useTypedFlags";

export function useRulesSuggestionAvailable(): boolean {
    const { transactionRuleSuggestions } = useTypedFlags();
    const workspaceAssignment = useActiveWorkspaceAssigment();
    const organizationAssignment = useActiveOrganizationAssignment();
    return (
        transactionRuleSuggestions &&
        (workspaceAssignment?.role === UserWorkspaceRole.ACCOUNTANT ||
            workspaceAssignment?.organizationId != null ||
            organizationAssignment != null)
    );
}
